import { Skeleton as SK, SkeletonProps } from '@mui/material';
import React from 'react';

interface ISkeletonProps extends SkeletonProps {
    backgroundColor?: string; // Optional color prop to customize the skeleton color
}

export const Skeleton: React.FC<ISkeletonProps> = ({ backgroundColor = '#919292', sx, ...props }) => {
    return (
        <SK
            sx={{
                backgroundColor, // Use the color prop
                ...sx, // Merge any other sx props passed
            }}
            {...props}
        />
    );
};
